import { createSelector } from '@ngrx/store';
import * as fromLocationFilters from '../reducers/location-filters.reducer';
import { selectLocationFilterState } from '../reducers';

export const getSelectedFilters = createSelector(
  selectLocationFilterState,
  fromLocationFilters.getSelectedFilters,
);

export const getLocationsSortBy = createSelector(
  selectLocationFilterState,
  fromLocationFilters.getLocationSortBy,
);

export const getLocationsSearchText = createSelector(
  selectLocationFilterState,
  fromLocationFilters.getLocationsSearchText,
);

export const getLocationSortByList = createSelector(
  selectLocationFilterState,
  fromLocationFilters.getLocationSortByList,
);
